"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../BaseComponent");
var Cookies = require("js-cookie");
var HegydCore_1 = require("./hegyd/hegyd-core/HegydCore");
var PopIn = /** @class */ (function (_super) {
    __extends(PopIn, _super);
    function PopIn($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        _this.lock = false;
        return _this;
    }
    PopIn.prototype.bind = function () {
        this.init();
    };
    PopIn.prototype.init = function () {
        var _this = this;
        var self = this;
        var data = this.getCookieData();
        // On évite de spam le JS si on a déja cliqué dans la popUp
        if (!data || data.clicked === 0) {
            // On vérifie toutes les 3 secs le timer de la Pop-In
            self.popInInterval = window.setInterval(function () {
                // On vérifie que la popUp n'est pas affichée et que l'utilisateur n'a pas cliqué sur le btn close
                data = _this.getCookieData();
                if (!data || (!self.popInIsDisplayed() && data.clicked === 0)) {
                    self.initPopInLogic();
                }
            }, 3000);
        }
    };
    PopIn.prototype.initPopInLogic = function () {
        if (!this.thereIsCookiePopIn()) {
            this.initCookie();
        }
        if (this.thereIsCookiePopIn() && this.cookieDateIsAfterTimer() && this.lock === false) {
            this.toggleLockedState(true);
            this.showPopIn();
        }
    };
    PopIn.prototype.cookieDateIsAfterTimer = function () {
        var data = this.getCookieData();
        var now = Date.now();
        var diffMs = now - data.created; // diff in milliseconds
        var diffSecs = Math.round(diffMs / 1000); // seconds
        return diffSecs > parseInt(document.getElementById('popIn').getAttribute('data-delay'));
    };
    PopIn.prototype.thereIsCookiePopIn = function () {
        return typeof Cookies.get('pop_in') !== 'undefined';
    };
    PopIn.prototype.initCookie = function () {
        Cookies.set('pop_in', JSON.stringify({ clicked: 0, created: Date.now() }), {
            sameSite: 'strict',
            expires: parseInt(document.getElementById('popIn').getAttribute('data-expiration')),
        });
    };
    PopIn.prototype.popInClicked = function () {
        Cookies.set('pop_in', JSON.stringify({ clicked: 1, created: Date.now() }), {
            sameSite: 'strict',
            expires: parseInt(document.getElementById('popIn').getAttribute('data-expiration')),
        });
    };
    PopIn.prototype.popInIsDisplayed = function () {
        return document.getElementById("popIn") && document.getElementById("popIn").childElementCount > 0;
    };
    PopIn.prototype.getCookieData = function () {
        return this.thereIsCookiePopIn() ? JSON.parse(Cookies.get('pop_in')) : null;
    };
    PopIn.prototype.showPopIn = function () {
        var _this = this;
        var self = this;
        var element = document.getElementById('popIn');
        HegydCore_1.default.sendRequest(element.getAttribute('data-url'), 'GET', [], function (data) {
            if (data) {
                // On précharge l'image de la popIn
                var img = new Image();
                img.src = data.image;
                // On retarde l'affichage de la popIn le temps que le préchargement de l'image se fasse
                setTimeout(function () {
                    document.getElementById('popIn').insertAdjacentHTML('beforeend', data.template);
                    self.initListeners();
                }, 500);
                _this.toggleLockedState(false);
            }
        }, function () {
            document.getElementById('popIn').classList.add('d-none');
            clearInterval(self.popInInterval);
            _this.toggleLockedState(false);
        });
    };
    PopIn.prototype.initListeners = function () {
        var self = this;
        var closeActions = document.querySelectorAll('#popIn .close-action');
        closeActions.forEach(function (closeAction) {
            closeAction.addEventListener('click', function () {
                self.popInClicked();
                document.querySelector('#popIn').remove();
            });
        });
        document.querySelectorAll('#popIn a').forEach(function (element) {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                self.popInClicked();
                window.location.assign(element.getAttribute('href'));
            });
        });
    };
    PopIn.prototype.toggleLockedState = function (state) {
        this.lock = state;
    };
    return PopIn;
}(BaseComponent_1.default));
exports.default = PopIn;
